import axios from "axios";
import { VRBO_URL } from "@/data/property";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export { API };

// Fire-and-forget analytics for VRBO click-throughs, then open the listing.
export function bookOnVrbo(source = "unknown") {
  try {
    axios.post(`${API}/events`, { type: "vrbo_click", path: source }).catch(() => {});
  } catch (_) {
    /* non-blocking */
  }
  window.open(VRBO_URL, "_blank", "noopener,noreferrer");
}
